module.exports = __webpack_public_path__ + "img/semiRing3.5add80fa.svg";